<template>
    <b-modal
        id="improve-us-widget-modal"
        ref="improve-modal"
        modal-class="apprentice-default-modal"
        :title="$t('dashboard.help_us_improve')"
        @ok="submitform"
        ok-variant="primary"
        :ok-title="$t('common.send')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary">
        <design-2021-apprentice-help-us-improve-form-component
            @state="stateUpdate"
            ref="improveForm"
            :hide-submit-button="true">
        </design-2021-apprentice-help-us-improve-form-component>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-dashboard-improve-us-widget-modal-component',
    methods: {
        stateUpdate(status) {
            status && this.$refs['improve-modal'].hide();
        },

        submitform(bvModalEvt) {
            bvModalEvt.preventDefault();
            this.$refs.improveForm.submit();
        },
    },
};
</script>

<style scoped></style>
